import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Renderer2, HostListener } from '@angular/core';

declare let $;
declare let window;

@Component({
  selector: 'app-mgrab-page',
  templateUrl: './mgrab-page.component.html',
  styleUrls: ['./mgrab-page.component.scss']
})
export class MgrabPageComponent implements OnInit, AfterViewInit {

  @ViewChild('homeSection') homeSection: ElementRef;
  @ViewChild('homeTriang') homeTriang: ElementRef;
  @ViewChild('homeImage') homeImage: ElementRef;
  @ViewChild('homeText') homeText: ElementRef;
  @ViewChild('challengeSection') challengeSection: ElementRef;
  @ViewChild('foryouSection') foryouSection: ElementRef;
  @ViewChild('foryouImage') foryouImage: ElementRef;
  @ViewChild('foryouText') foryouText: ElementRef;
  @ViewChild('quoteText') quoteText: ElementRef;
  @ViewChild('itworksSection') itworksSection: ElementRef;
  @ViewChild('itworksImage') itworksImage: ElementRef;
  @ViewChild('itworksText') itworksText: ElementRef;
  @ViewChild('storeImages') storeImages: ElementRef;
  @ViewChild('storeBubble1') storeBubble1: ElementRef;
  @ViewChild('storeBubble2') storeBubble2: ElementRef;
  @ViewChild('storeBubble3') storeBubble3: ElementRef;
  @ViewChild('storeBubble4') storeBubble4: ElementRef;
  @ViewChild('benefitsSection') benefitsSection: ElementRef;
  @ViewChild('benefitsImage') benefitsImage: ElementRef;

  constructor(private renderer: Renderer2) {
  }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  ngAfterViewInit() {
    this.homeScreenLaying();
    this.renderer.addClass(this.homeTriang.nativeElement, 'fadeInDown');
    this.renderer.addClass(this.homeImage.nativeElement, 'fadeInLeft');
    this.renderer.addClass(this.homeText.nativeElement, 'fadeIn');
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.pageYOffset;

    if ( scrollPosition >= this.challengeSection.nativeElement.offsetTop - window.innerHeight) {
      this.renderer.addClass(this.challengeSection.nativeElement, 'show');
      this.renderer.addClass(this.challengeSection.nativeElement, 'fadeIn');
    }
    if ( scrollPosition >= this.foryouSection.nativeElement.offsetTop - window.innerHeight) {
      this.renderer.addClass(this.foryouSection.nativeElement, 'show');
      this.renderer.addClass(this.foryouText.nativeElement, 'fadeIn');
      this.renderer.addClass(this.foryouImage.nativeElement, 'fadeInRight');
      this.renderer.addClass(this.quoteText.nativeElement, 'fadeInLeft');
    }
    if ( scrollPosition >= this.itworksSection.nativeElement.offsetTop - window.innerHeight) {
      this.renderer.addClass(this.itworksSection.nativeElement, 'show');
      this.renderer.addClass(this.itworksSection.nativeElement, 'fadeIn');
      this.renderer.addClass(this.storeImages.nativeElement, 'fadeInUp');
      setTimeout(
        () => {
          this.renderer.addClass(this.storeBubble1.nativeElement, 'show');
          this.renderer.addClass(this.storeBubble1.nativeElement, 'bounceIn');
        }, 750 );
      setTimeout(
        () => {
          this.renderer.addClass(this.storeBubble2.nativeElement, 'show');
          this.renderer.addClass(this.storeBubble2.nativeElement, 'bounceIn');
        }, 1000 );
      setTimeout(
        () => {
          this.renderer.addClass(this.storeBubble3.nativeElement, 'show');
          this.renderer.addClass(this.storeBubble3.nativeElement, 'bounceIn');
        }, 1250 );
      setTimeout(
        () => {
          this.renderer.addClass(this.storeBubble4.nativeElement, 'show');
          this.renderer.addClass(this.storeBubble4.nativeElement, 'bounceIn');
        }, 1500 );

    }
    if ( scrollPosition >= this.benefitsSection.nativeElement.offsetTop - window.innerHeight) {
      this.renderer.addClass(this.benefitsSection.nativeElement, 'show');
      this.renderer.addClass(this.benefitsSection.nativeElement, 'fadeIn');
      this.renderer.addClass(this.benefitsImage.nativeElement, 'show');
      this.renderer.addClass(this.benefitsImage.nativeElement, 'fadeInLeft');
    }
  }

  private homeScreenLaying() {
    const screenHeight = window.innerHeight;
    $('#blank').height(screenHeight * 0.10);
    $('#content').height(screenHeight * 0.9);
  }

}
